import { useEffect } from 'react'
import { isNativeApp } from './nativeAuth'

/** Track virtual-keyboard overlap for composer / bottom-fixed UI. */
export function useKeyboardInset(enabled = true): void {
  useEffect(() => {
    if (!enabled) return
    const vv = window.visualViewport
    if (!vv) return

    const update = () => {
      const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop)
      document.documentElement.style.setProperty('--keyboard-inset', `${Math.round(inset)}px`)
    }

    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)
    update()

    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
      document.documentElement.style.removeProperty('--keyboard-inset')
    }
  }, [enabled])
}

/** Scroll focused inputs into view when the keyboard opens (native WebView). */
export function useScrollFocusedFieldIntoView(enabled = true): void {
  useEffect(() => {
    if (!enabled || !isNativeApp()) return

    const onFocusIn = (e: FocusEvent) => {
      const el = e.target
      if (!(el instanceof HTMLElement)) return
      if (!el.matches('input, textarea, select')) return
      window.setTimeout(() => {
        el.scrollIntoView({ block: 'center', behavior: 'smooth' })
      }, 280)
    }

    document.addEventListener('focusin', onFocusIn)
    return () => document.removeEventListener('focusin', onFocusIn)
  }, [enabled])
}
